import sortBy from 'lowscore/sortBy.js'

export function mostRecentlyCreatedDiscount (discounts) {
  return sortBy(discounts, 'createdDate').reverse()[0]
}
